/* global angular, swal, _ */

export default function($scope, $stateParams, $timeout, Swal, ProfileClass, ApiClass, $uibModalInstance) {
  'ngInject';

  const { profile } = ProfileClass.profileComplete;
  const profile_uid = $stateParams.employeeID || $stateParams.id || profile.profile_uid;

  $scope.resultsQueried = false;
  $scope.formData = ProfileClass.userProfile;
  $scope.profileUpdate = false;

  $timeout(() => {
    $scope.resultsQueried = true;
  }, 0);

  $scope.update = function() {
    $scope.profileUpdate = true;
    ApiClass.usersIdPatch({ id: profile_uid }, $scope.formData).then(() => {
      $scope.profileUpdate = false;
      $uibModalInstance.dismiss('cancel');
      if (ProfileClass.errors) Swal.toast('Error, please review and submit again', 'error');
      else Swal.toast('Updated, your profile has been updated');
      $scope.profileForm.$setPristine();
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/modals/selfStudyFInal/index.js